<div class="modal-wrapper">
  <div class="modal-header d-flex align-items-center justify-content-between">
    <h4 class="block-title mb-0">Billing Address</h4>
    <button class="material-icons" mat-dialog-close>close</button>
  </div>

  <div class="modal-content p4">
    <form [formGroup]="billingAddressForm">
      <div class="row">

        <!-- Country -->
        <div class="col-12">
          <div class="detail-block">
            <div class="detail-block-label">
              <span>{{'Country' | translate}}</span>
            </div>
            <div class="detail-block-value">
              <mat-form-field appearance="outline" floatLabel="never">
                <mat-select class="country" formControlName="Country">
                  <mat-select-trigger>
                    {{ this.countrySelected }}
                  </mat-select-trigger>
                  <mat-option *ngFor="let countryCode of cc; let i = index"
                              (click)="countrySelectedd(i)"
                              [value]="countryCode.name">
                    <span class="{{'fi fi-'+ countryCode.code.toLowerCase()}}"></span>
                    {{ countryCode.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- State -->
        <div class="col-12">
          <div class="detail-block">
            <div class="detail-block-label">
              <span>{{'State / Jurisdiction' | translate}}</span>
            </div>
            <div class="detail-block-value">
              <mat-form-field appearance="outline" floatLabel="never">
                <input matInput type="text" placeholder="{{'Enter' | translate}}..."
                       formControlName="State">
                <mat-error *ngIf="billingAddressForm?.get('State')?.hasError('required')">
                  {{'State is required' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- City -->
        <div class="col-12">
          <div class="detail-block">
            <div class="detail-block-label">
              <span>{{'City' | translate}}</span>
            </div>
            <div class="detail-block-value">
              <mat-form-field appearance="outline" floatLabel="never">
                <input matInput type="text" placeholder="{{'Enter' | translate}}..."
                       formControlName="City">
                <mat-error *ngIf="billingAddressForm?.get('City')?.hasError('required')">
                  {{'City is required' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Zip Code -->
        <div class="col-12">
          <div class="detail-block">
            <div class="detail-block-label">
              <span>{{'Zip Code' | translate}}</span>
            </div>
            <div class="detail-block-value">
              <mat-form-field appearance="outline" floatLabel="never">
                <input matInput type="text" placeholder="{{'Enter' | translate}}..."
                       formControlName="ZipCode">
                <mat-error *ngIf="billingAddressForm?.get('ZipCode')?.hasError('required')">
                  {{'Zip Code is required' | translate}}
                </mat-error>
                <mat-error *ngIf="billingAddressForm?.get('ZipCode')?.hasError('pattern')">
                  {{'Invalid Zip Code format' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Address Line 1 -->
        <div class="col-12">
          <div class="detail-block">
            <div class="detail-block-label">
              <span>{{'Address line 1' | translate}}</span>
            </div>
            <div class="detail-block-value">
              <mat-form-field appearance="outline" floatLabel="never">
                <input matInput type="text" placeholder="{{'Enter' | translate}}..."
                       formControlName="AddressLine1">
                <mat-error *ngIf="billingAddressForm?.get('AddressLine1')?.hasError('required')">
                  {{'Address Line 1 is required' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Address Line 2 -->
        <div class="col-12">
          <div class="detail-block">
            <div class="detail-block-label">
              <span>{{'Address line 2' | translate}}</span>
            </div>
            <div class="detail-block-value">
              <mat-form-field appearance="outline" floatLabel="never">
                <input matInput type="text" placeholder="{{'Enter' | translate}}..."
                       formControlName="AddressLine2">
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Company Name -->
        <div class="col-12">
          <div class="detail-block">
            <div class="detail-block-label">
              <span>{{'Company Name' | translate}}</span>
            </div>
            <div class="detail-block-value">
              <mat-form-field appearance="outline" floatLabel="never">
                <input matInput type="text" placeholder="{{'Enter' | translate}}..."
                       formControlName="CompanyName">
              </mat-form-field>
            </div>
          </div>
        </div>

      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div class="button-wrapper">
      <button class="btn btn-link" type="button" mat-dialog-close>
        {{'Cancel' | translate}}
      </button>
      <button class="btn btn-primary" type="button" (click)="onUpdate()">
        Update
      </button>
    </div>
  </div>
</div>
